<nav class="nav bg_color_black">
    <div class="menu row">
        <ul class="list fw_500 fz_s color_text_gray">
            <li class="item">
                <a routerLink="dashboard" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        dashboard
                    </span>
                    <p class="text">Дашборд</p>
                </a>
            </li>
            <li class="item">
                <a routerLink="customers" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        group
                    </span>
                    <p class="text">Клиенты</p>
                </a>
            </li>
            <li class="item">
                <a routerLink="orders" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        orders
                    </span>
                    <p class="text">Заказы</p>
                </a>
            </li>
            <li class="item">
                <a routerLink="accounts" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        subscriptions
                    </span>
                    <p class="text">Подписки</p>
                </a>
            </li>
            <li class="item">
                <a routerLink="products" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        inventory_2
                    </span>
                    <p class="text">Товары</p>
                </a>
            </li>
            <li class="item">
                <a routerLink="tasks" routerLinkActive="link_active" class="link row">
                    <span class="material-symbols-outlined">
                        inventory
                    </span>
                    <p class="text">Задачи</p>
                </a>
            </li>
        </ul>
        <ul class="list fw_500 fz_s color_text_gray">
            <li class="item logout">
                <button (click)="openModal('logoutPopup')" class="link row">
                    <span class="material-symbols-outlined">
                        logout
                    </span>
                    <p class="text">Выход</p>
                </button>
            </li>
        </ul>
    </div>
</nav>
<app-confirm-modal *ngIf="(modalService.modalState$ | async) == 'logoutPopup'" title="Вы действительно хотите выйти?" buttonText="Выйти" (clear)="logout()"></app-confirm-modal>
